(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["db-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const sheets=root.querySelector('.dbc-sheets');
    const groups=[...root.querySelectorAll('[data-sheet]')];
    const tabs=[...root.querySelectorAll('[data-category]')];
    const status=root.querySelector('[data-catalog-status]');
    const reduce=matchMedia('(prefers-reduced-motion: reduce)');
    let active=0;
    const behavior=()=>reduce.matches?'instant':'smooth';
    const rails=groups.map(group=>{const items=[...group.querySelectorAll('[data-product]')];return {group,el:group.querySelector('.dbc-rail'),items,allItems:items,index:0};});
    function updateCategory(){
      if(!sheets.clientHeight||!groups.length)return;
      const next=Math.max(0,Math.min(groups.length-1,Math.round(sheets.scrollTop/sheets.clientHeight)));
      const changed=next!==active;active=next;
      tabs.forEach((tab,i)=>{if(i===active)tab.setAttribute('aria-current','true');else tab.removeAttribute('aria-current');});
      root.querySelectorAll('[data-category-step]').forEach(b=>b.disabled=Number(b.dataset.categoryStep)<0?active===0:active===groups.length-1);
      if(changed)status.textContent=groups[active].dataset.name;
    }
    function goCategory(index){if(!groups.length)return;index=Math.max(0,Math.min(groups.length-1,index));sheets.scrollTo({top:index*sheets.clientHeight,behavior:behavior()});}
    function updateProducts(rail){
      if(!rail.el.clientWidth)return;
      rail.index=Math.max(0,Math.min(rail.items.length-1,Math.round(rail.el.scrollLeft/rail.el.clientWidth)));
      rail.items.forEach((item,i)=>{item.inert=i!==rail.index;});
      rail.group.querySelectorAll('[data-product-step]').forEach(b=>b.disabled=rail.items.length<2);
    }
    function goProduct(rail,index){const count=rail.items.length;if(count<2)return;const wrap=index<0||index>=count;index=((index%count)+count)%count;rail.el.scrollTo({left:index*rail.el.clientWidth,behavior:wrap?'instant':behavior()});updateProducts(rail);}
    function filterProducts(rail,button){
      const category=button.dataset.subcategory;
      rail.allItems.forEach(item=>{item.hidden=category!=='all'&&!item.dataset.subtypes.split(' ').includes(category);item.inert=item.hidden;});
      rail.items=rail.allItems.filter(item=>!item.hidden);rail.index=0;
      rail.el.scrollTo({left:0,behavior:'instant'});
      rail.group.querySelectorAll('[data-subcategory]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      updateProducts(rail);
      status.textContent=rail.group.dataset.name+' — '+button.textContent;
    }
    root.addEventListener('click',e=>{
      const sub=e.target.closest('[data-subcategory]');if(sub){const rail=rails.find(r=>r.group===sub.closest('[data-sheet]'));filterProducts(rail,sub);return;}
      const tab=e.target.closest('[data-category]');if(tab){goCategory(Number(tab.dataset.category));return;}
      const cat=e.target.closest('[data-category-step]');if(cat){goCategory(active+Number(cat.dataset.categoryStep));return;}
      const product=e.target.closest('[data-product-step]');if(product){const rail=rails.find(r=>r.group===product.closest('[data-sheet]'));goProduct(rail,rail.index+Number(product.dataset.productStep));}
    });
    root.addEventListener('keydown',e=>{
      if(e.altKey||e.metaKey||e.ctrlKey||e.target.matches('input,textarea,select'))return;
      if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();goCategory(active+(e.key==='ArrowDown'?1:-1));}
      if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();const rail=rails[active];if(rail)goProduct(rail,rail.index+(e.key==='ArrowRight'?1:-1));}
    });
    sheets.addEventListener('scroll',updateCategory,{passive:true});
    rails.forEach(rail=>{
      const edge=()=>({first:rail.el.scrollLeft<=2,last:rail.el.scrollLeft>=rail.el.scrollWidth-rail.el.clientWidth-2});
      const wrapEdge=(state,delta)=>{if(rail.items.length<2)return false;if(state.first&&delta<0){goProduct(rail,-1);return true;}if(state.last&&delta>0){goProduct(rail,rail.items.length);return true;}return false;};
      let touch=null,lastWheel=0,wheelState=null,wheelDistance=0,wheelWrapped=false;
      rail.el.addEventListener('touchstart',e=>{touch=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY,...edge()}:null;},{passive:true});
      rail.el.addEventListener('touchend',e=>{if(!touch)return;const point=e.changedTouches[0],dx=touch.x-point.clientX,dy=touch.y-point.clientY;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.4)wrapEdge(touch,dx);touch=null;},{passive:true});
      rail.el.addEventListener('touchcancel',()=>{touch=null;},{passive:true});
      rail.el.addEventListener('wheel',e=>{
        const now=performance.now();if(now-lastWheel>180){wheelState=edge();wheelDistance=0;wheelWrapped=false;}lastWheel=now;
        const dx=e.shiftKey&&!e.deltaX?e.deltaY:e.deltaX;
        if(!dx||(!e.shiftKey&&Math.abs(dx)<=Math.abs(e.deltaY)))return;
        if(wheelWrapped){e.preventDefault();return;}
        if(rail.items.length>1&&((wheelState?.first&&dx<0)||(wheelState?.last&&dx>0))){e.preventDefault();wheelDistance+=dx;if(Math.abs(wheelDistance)>45)wheelWrapped=wrapEdge(wheelState,wheelDistance);}
      },{passive:false});
      rail.el.addEventListener('scroll',()=>updateProducts(rail),{passive:true});updateProducts(rail);
    });
    new ResizeObserver(()=>{sheets.scrollTo({top:active*sheets.clientHeight,behavior:'instant'});rails.forEach(r=>{r.el.scrollTo({left:r.index*r.el.clientWidth,behavior:'instant'});updateProducts(r);});updateCategory();}).observe(sheets);
    updateCategory();
  }
  document.querySelectorAll('[data-catalog]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-catalog]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["db-entry"] && !Shopify.designMode) return;
  try {
    
(() => {
  const gate=document.querySelector('#db-access');
  if(!gate || gate.dataset.initialized) return;
  gate.dataset.initialized='true';
  const sessionKey='death-beyond-entry-v2';
  const duration=24*60*60*1000;
  const isEditor=Boolean(window.Shopify?.designMode);
  let admitted=false;
  try{const expires=Number(localStorage.getItem(sessionKey));admitted=expires>Date.now() && expires<=Date.now()+duration;}catch{}
  if(admitted && !isEditor){gate.hidden=true;gate.querySelector('video')?.pause();if(gate.dataset.index!=='true')window.location.replace(gate.dataset.home);return;}
  const copy=gate.querySelector('#db-copy').dataset;
  const video=gate.querySelector('video');
  const motion=gate.querySelector('#db-motion');
  video.muted=true;
  const motionText=()=>{motion.textContent=video.paused?copy.play:copy.pause;};
  motion.addEventListener('click',()=>{if(video.paused)video.play().catch(motionText);else video.pause();});
  video.addEventListener('play',motionText);video.addEventListener('pause',motionText);
  video.play().catch(motionText);
  const clock=()=>{gate.querySelector('#db-clock').textContent=new Intl.DateTimeFormat('en-US',{hour:'numeric',minute:'2-digit',timeZone:'America/New_York',timeZoneName:'short'}).format(new Date());};
  clock();const clockTimer=setInterval(clock,1000);
  const codeForm=gate.querySelector('#db-code-form');
  const input=gate.querySelector('#db-code');
  const digits=gate.querySelector('#db-digits');
  const feedback=gate.querySelector('#db-feedback');
  const enter=gate.querySelector('#db-enter');
  const loading=gate.querySelector('#db-loading');
  let root,email,phone,nativeForm,nativeSubmit,code='',identity='',submitted=false,done=false;
  let submitTimer;
  const contactValid=()=>email && phone && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()) && phone.value.replace(/\D/g,'').length>=7 && phone.value.replace(/\D/g,'').length<=15;
  function newCode(){let next;do{next=String(1000+crypto.getRandomValues(new Uint32Array(1))[0]%9000);}while(next===code);code=next;digits.textContent=code;digits.setAttribute('aria-label',code.split('').join(' '));input.value='';input.removeAttribute('aria-invalid');feedback.textContent='';}
  function sync(){
    const valid=contactValid();codeForm.hidden=!valid;
    if(!valid){code='';identity='';digits.textContent='';input.value='';return false;}
    const next=email.value.trim().toLowerCase()+'|'+phone.value.replace(/\D/g,'');
    if(next!==identity || !code){identity=next;newCode();}
    return true;
  }
  function guard(event){
    if(!sync() || input.value!==code){event.preventDefault();event.stopImmediatePropagation();feedback.textContent=copy.mismatch;input.setAttribute('aria-invalid','true');if(!codeForm.hidden)input.focus();return false;}
    submitted=true;
    feedback.textContent=copy.saving;enter.disabled=true;
    clearTimeout(submitTimer);submitTimer=setTimeout(()=>{if(!done){enter.disabled=false;feedback.textContent='';}},12000);
    return true;
  }
  function complete(){
    if(done || !submitted) return;
    done=true;clearTimeout(submitTimer);feedback.textContent=copy.saved;
    try{if(!isEditor)localStorage.setItem(sessionKey,String(Date.now()+duration));}catch{}
    if(gate.dataset.index==='true'){gate.hidden=true;video.pause();clearInterval(clockTimer);window.scrollTo(0,0);}
    else{window.location.assign(gate.dataset.home);}
  }
  function inspect(){
    if(root?.querySelector('[data-current-step="success"]')) complete();
    if(root?.querySelector('[aria-invalid="true"]')){enter.disabled=false;feedback.textContent='';}
  }
  function connect(){
    const host=gate.querySelector('shopify-forms-embed');
    const candidate=host?.shadowRoot;
    const form=candidate?.querySelector('form[data-testid="form"]');
    if(!form)return false;
    root=candidate;nativeForm=form;email=root.querySelector('#email');phone=root.querySelector('#phone_number');nativeSubmit=root.querySelector('[data-testid="btn-form-submit"]');
    if(!email || !phone || !nativeSubmit)return false;
    const style=document.createElement('style');
    style.textContent=':host{--container-background-color:transparent!important;--container-text-alignment:left!important;--forms-padding-bottom:0px!important;--body-text-color:#fff!important;--heading-text-color:#fff!important;--form-field-border-radius:0px!important;--button-border-radius:0px!important;--container-max-w:380px!important;--inline-container-max-width:380px!important;--spacing-size:0px!important;--spacing-size-x:0px!important;--spacing-size-y:0px!important;--app-embed-padding-x:0px!important;--app-embed-padding-y:0px!important;--forms-heading-font-size:12px!important;--forms-body-font:normal 400 13px Arial,sans-serif!important;} h2{display:none!important} [data-testid="btn-form-submit"]{display:none!important} input{font-size:16px!important} form{gap:12px!important}';
    root.appendChild(style);
    nativeForm.addEventListener('submit',guard,true);
    root.addEventListener('input',event=>{if(event.target===email || event.target===phone)sync();});
    root.addEventListener('change',sync);
    new MutationObserver(inspect).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['data-current-step','aria-invalid']});
    loading.hidden=true;sync();return true;
  }
  gate.querySelector('#db-refresh').addEventListener('click',()=>{if(sync()){newCode();input.focus();}});
  input.addEventListener('input',()=>{input.value=input.value.replace(/\D/g,'').slice(0,4);input.removeAttribute('aria-invalid');feedback.textContent='';});
  codeForm.addEventListener('submit',event=>{event.preventDefault();if(!nativeForm || enter.disabled)return;if(!sync() || input.value!==code){feedback.textContent=copy.mismatch;input.setAttribute('aria-invalid','true');input.focus();return;}nativeForm.requestSubmit(nativeSubmit);});
  let attempts=0;const timer=setInterval(()=>{if(connect()){clearInterval(timer);}else if(++attempts>=120){clearInterval(timer);loading.textContent=copy.loadingError;}},250);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["db-product"]) return;
  try {
    
(() => {
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const media=[...root.querySelectorAll('[data-media]')];
    const thumbs=[...root.querySelectorAll('[data-thumbnail]')];
    function show(id){
      if(!media.some(m=>m.dataset.media===id))return;
      media.forEach(m=>{m.hidden=m.dataset.media!==id;if(m.hidden)m.querySelectorAll('video').forEach(v=>v.pause());});
      thumbs.forEach(t=>t.setAttribute('aria-pressed',String(t.dataset.thumbnail===id)));
    }
    thumbs.forEach(t=>t.addEventListener('click',()=>show(t.dataset.thumbnail)));
    root.addEventListener('db:variant',e=>{
      const {variant,options}=e.detail;
      if(variant.media)show(variant.media);
      const color=root.querySelector('[data-product-color]');if(color)color.textContent=options[Number(color.dataset.colorPosition)];
      const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
    });
  }
  document.querySelectorAll('[data-db-product]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-db-product]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
